require('./club-hole-by-hole-bar-chart.jade')
_ = require('lodash')

MAX_LEVEL = 3
MIN_LEVEL = -2

ClubHoleByHoleBarChartDirective = (NumberService) ->
  restrict: "A"
  replace: false
  templateUrl: "club/club-hole-by-hole/club-hole-by-hole-bar-chart.jade"
  scope:
    holes: '=holes'
  link: (scope, element) ->
    target = element.find(".chart")

    scope.formatEmptyValue = (value)->
      if value == null || value == undefined || value == ''
        return '-'
      return value

    scope.decorate = (holes) ->
      _.map holes, (hole) ->
        # calculate stroke
        hole.stroke = hole.avg_shot - hole.par if hole.avg_shot != null && hole.avg_shot != undefined

        # Rate to percent value (ex. 0.9 => 90.00)
        hole.par_on_percent = scope.formatEmptyValue(NumberService.limitFractional(hole.rat_par_on * 100))
        hole.bogey_on_percent = scope.formatEmptyValue(NumberService.limitFractional(hole.rat_bogey_on * 100))
        hole.recovery_percent = scope.formatEmptyValue(NumberService.limitFractional(hole.rat_recovery * 100))

        hole
    # decorate response data
    scope.decorate(scope.holes)

    scope.outIn = ['OUT', 'IN']

    # default selected button (Score/Putt)
    scope.selectedButton = 'SCR'

    scope.isSelected = (type)->
      scope.selectedButton == type

    # Click button
    scope.clickButton = (type)->
      scope.selectedButton = type

    # Check whethere visible or not
    # level: -2, -1, 1, 2, 3
    # value: stroke or putt
    scope.isVisbleBarCol = (level, value)->
      # ex) level=1, value=1.9 => true
      #     level=2, value=1.9 => true
      #     level=3, value=1.9 => false
      #     level=-1, value=-0.5 => true
      #     level=-2, value=-0.5 => false
      if level > 0
        level < value + 1
      else
        level > value - 1

    # Get stroke col width(%)
    scope.getStrokeColWidthPercent = (level, value)->
      if level > 0
        max = scope.maxStroke()
        if level < MAX_LEVEL && level <= value
          return 1 / max * 100
        else
          ratio = scope.getColumnWidthRatio(value)
          return ratio / max * 100
      else
        min = Math.abs(scope.minStroke())
        if level > MIN_LEVEL && level >= value
          return 1 / min * 100
        else
          ratio = scope.getColumnWidthRatio(value)
          return ratio / min * 100

    # Get putt col width(%)
    scope.getPuttColWidthPercent = (level, value)->
      max = scope.maxPutt()
      if level < MAX_LEVEL && level <= value
        return 1 / max * 100
      else
        ratio = scope.getColumnWidthRatio(value)
        return ratio / max * 100


    # Get column width ratio
    # ex) stroke=3.5  (over max level)     => 1.5
    #     stroke=4.5  (over max level)     => 2.5
    #     stroke=-0.5 (not over min level) => 0.5
    #     stroke=-1.2 (not over min level) => 0.2
    #     stroke=-2.1 (over min level)     => 1.1
    scope.getColumnWidthRatio = (value) ->
      return value - (MAX_LEVEL - 1)           if value >= MAX_LEVEL
      return Math.abs(value) + (MIN_LEVEL + 1) if value <= MIN_LEVEL
      intDecimal = String(value).split('.')
      return '0' if intDecimal.length != 2
      return parseFloat('0.' + intDecimal[1])

    minStroke = null
    maxStroke = null
    maxPutt = null

    # Get max value of putt
    scope.maxPutt = ->
      return maxPutt if maxPutt
      value = _.maxBy(scope.holes, (hole) -> hole.avg_putt)

      maxPutt = value?.avg_putt
      return maxPutt

    # Get max value of stroke
    scope.maxStroke = ->
      return maxStroke if maxStroke
      value = _.maxBy scope.holes, (hole) ->
        hole.stroke
      maxStroke = value?.stroke
      return maxStroke

    # Get min value of stroke
    scope.minStroke = ->
      return minStroke if minStroke
      value = _.min scope.holes, (hole) ->
        hole.stroke
      minStroke = value.stroke
      return minStroke

    scope.sliceHoles = (outInType, holes)->
      if outInType == 'OUT'
        return holes.slice(0, 9)
      else
        return holes.slice(9, 18)

    scope.getColorForStroke = (hole) ->
      return 'chance-hall-color' if hole.stroke == 0
      return unless hole.stroke
      if hole.stroke < 1
        return 'chance-hall-color'
      else if hole.stroke >= 2
        return 'difficult-hall-color'

    scope.getColorForPutt = (hole) ->
      return 'one-putt-color' if hole.avg_putt == 0
      return unless hole.avg_putt
      if hole.avg_putt >= 3
        return 'three-putts-color'
      else if hole.avg_putt < 2
        return 'one-putt-color'

ClubHoleByHoleBarChartDirective.$inject = [
  "NumberService"
]

module.exports = ClubHoleByHoleBarChartDirective



// WEBPACK FOOTER //
// ./~/coffeelint-loader!./ngapp/javascript/web/club/club-hole-by-hole/club-hole-by-hole-bar-chart-directive.coffee